<template>
  <router-link :to="path" class="mw-home-card-item">
    <IconWrapper :size="20" :icon="type ? icons[type] : icons.Case" />
    <TextEllipsis class="mw-home-card-item-label" :text="label" />
  </router-link>
</template>

<script>
import articleIcon from '@/assets/article-icon-v2.1.svg';
import diagIcon from '@/assets/diag-icon-v2.1.svg';
import { grey5Mayday } from '@/assets/scss/_colors.scss';
import IconWrapper from '@/components/IconWrapper';
import TextEllipsis from '@/components/TextEllipsis';
import { mapGetters } from 'vuex';

export default {
  components: { IconWrapper, TextEllipsis },
  name: 'mayday-web-home-card-item',
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: null,
    },
    label: {
      type: String,
    },
    caseParameters: {
      type: Array,
    },
  },
  data() {
    return {
      icons: {
        Diagnostic: {
          iconType: 'url',
          value: diagIcon,
          color: null,
        },
        Article: {
          iconType: 'url',
          value: articleIcon,
          color: null,
        },
        Case: {
          iconType: 'fa',
          value: 'folder',
          color: grey5Mayday,
        },
      },
    };
  },
  computed: {
    path() {
      const itemType = !this.type || this.type === 'Case' ? 'case' : `content`;

      return `/web/knowledge/${this.focusKnowledge.id}/${itemType}/${this.id}?source=navigation`;
    },
    ...mapGetters('webKnowledgeModule', ['focusKnowledge']),
  },
};
</script>

<style lang="scss" scoped>
.mw-home-card-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  height: 32px;
  background-color: transparent;
  &:hover {
    background-color: $grey-1-mayday;
  }
  &-label {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: $blue-9-mayday;
    width: 100%;
  }
}
</style>
